//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import ApiUrls from '@constants/ApiUrls';

const userApi = (api) => {
    return {
        login:          (
            email,
            password,
        ) => {
            return api.post(
                ApiUrls.API_TOKENS,
                {
                    email,
                    password,
                },
            );
        },
        removeToken:    () => {
            /* eslint-disable no-param-reassign */
            /* Not possible to disable this here since we actually have to remove this in the api object */
            delete api.headers.Authorization;
        },
        setToken:       (token) => {
            console.log('API: setToken', token);

            if (token) {
                const authorization = `Bearer ${token}`;

                api.setHeader('Authorization', authorization);
            } else {
                userApi(api).removeToken();
            }
        },
        fetchUser:      (iri) => {
            return api.get(iri);
        },
        saveUser:       (iri, user) => {
            return api.put(iri, user);
        },
        postUser:       (user) => {
            return api.post(
                ApiUrls.API_USERS,
                user,
            );
        },
        passwordReset:  (email) => {
            return api.post(
                ApiUrls.API_USERS_PASSWORD_RESET,
                {
                    email,
                },
            );
        },
        setNewPassword: (data) => {
            return api.post(
                ApiUrls.API_USERS_SET_NEW_PASSWORD,
                data,
            );
        },
    };
};

export default (api) => userApi(api);
